module.exports = __webpack_public_path__ + "img/icons BFr_22.fb82428f.png";